import api from 'config/api';

export default {
  getHistoryAdherence: clientNumber => api.get(`admin_api/v1/accounts/${clientNumber}/digital_bill/history`),
  getHistorySendBills: clientNumber =>
    api.get(`admin_api/v1/accounts/${clientNumber}/digital_bill/sent_emails`)
};
